// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyDMeKEFlZszjtA3zNsiXFSWSzs3QNmgqrk",
  authDomain: "blooddonation-7434c.firebaseapp.com",
  projectId: "blooddonation-7434c",
  storageBucket: "blooddonation-7434c.firebasestorage.app",
  messagingSenderId: "747227344711",
  appId: "1:747227344711:web:8f3fd3c2fb2d968fb26662",
  measurementId: "G-4T2PCW46ES"
};
